module.exports = __webpack_public_path__ + "img/user-pictogram.2fd68fd1.svg";